/* eslint-disable arrow-body-style */
/* eslint-disable react/self-closing-comp */

import React from 'react';
import { InfiniteScrollLoadTrigger } from '@src/common/InfiniteScrollLoadTrigger/InfiniteScrollLoadTrigger';
import {
  eventSearchResultsApi,
  useEventSearchResultsStore,
} from '../../../mothership/eventSearchResults.state';
import { eventSearchId } from '../../../types';

export const LoadTrigger = () => {
  const loading = useEventSearchResultsStore((state) => state.loadingMore);
  const moreToLoad = useEventSearchResultsStore((state) => state.moreToLoad);

  return (
    <InfiniteScrollLoadTrigger
      id={eventSearchId}
      loading={loading}
      moreToLoad={moreToLoad}
      setInfiniteScrollElement={eventSearchResultsApi.setInfiniteScrollElement}
    />
  );
};
